export default __webpack_public_path__ + "static/img_welfare_3-5f387d3adb737f4b73135179996dfd86.jpg";